import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import FullScreenLoader from "../../FullScreenLoader/fullScreenLoader";

const Traits = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [ntraits, setnTraits] = useState({});

  const [traits, setTraits] = useState([]);

  const [gameIds, setGameIds] = useState([]);

  const [ltraits, setlTraits] = useState({});

  const userData = useSelector((state) => state.userSlice);

  var uuid = userData?.user?.uuid;

  const configData = useSelector((state) => state.configSlice);

  const fetchnextplaydata = async () => {
    try {
      const response = await axios.get(`${configData?.config?.apiBaseUrl}/api/nextplay/${uuid}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      });
      setnTraits(response.data.data[0]);
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchTraitsData = async () => {
    try{
    const reponse = await axios.get(`${configData?.config?.apiBaseUrl}/api/fetchAllTraitsData`, {
      headers: {
        Authorization: `Bearer ${userData.token}`,
      },
    });
    setTraits(reponse?.data?.data);
    setLoading(false)
  }catch(err){
    console.log(err.message);
    navigate('/')
  }
  };

  const fetchlastplaydata = async () => {
    try {
      const response = await axios.get(`${configData?.config?.apiBaseUrl}/api/lastplay/${uuid}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      });
      setlTraits(response.data.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchGameIds = async () => {
    try {
      const response = await axios.get(`${configData?.config?.apiBaseUrl}/api/gamesPlayedToday/${uuid}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      });
      setGameIds(response.data.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchnextplaydata();
    fetchlastplaydata();
    fetchTraitsData();
    fetchGameIds();
  }, []);

  return (
    <>
    { loading?
   <div style={{display:'flex',justifyContent:'center'}}>
     <FullScreenLoader loading={loading}/>
   </div>
    :
     <div className="container-fluid p-4 insights">
        <div className="row">
          <div className="col-md-8">
            <h6 className="mb-3">Recommended Training For You</h6>
            <div className={`card h-100 overflow-hidden ${ntraits?.color}`}>
              <div className="card-body carddata">
                <div>
                  <h5>{ntraits?.name}</h5>
                  <p className="font-xss py-2">{ntraits?.description}</p>
                  <button
                    className="btn btn-primary font-xss px-4"
                    onClick={() =>
                      navigate(`/traits/playmodule/${ntraits?.games[0].id}`, {
                        state: { tid: ntraits?.id },
                      })
                    }
                  >
                    Play
                  </button>
                </div>
              </div>
              <img src={ntraits.icon} style={{ width: "170px" }} className="dashimg" alt="" />
            </div>
          </div>
          {ltraits ? (
            <div className="col-md-4">
              <h6 className="mb-3">Your Recent Exercise</h6>
              <div className={`card  h-100 ${ltraits?.color}`}>
                <div className="card-body carddata">
                  <div>
                    <h6>{ltraits?.name}</h6>
                    <p className="font-xss py-2 mb-0 pb-0">{ltraits?.description}</p>
                  </div>
                </div>
                <img src={ltraits?.icon} style={{ width: "130px" }} className="dashimg" alt="" />
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="row mt-5">
          <div className="col-md-12 py-2">
            <h5>Traits that you can train</h5>
          </div>
        </div>
        <div className="row traitslist">
          {traits.length > 0 && (
            <>
              {traits.map((item, index) => {
                return (
                  <div key={index} className="col-md-4 mb-4">
                    <div className={`card h-100 ${item.color} ${gameIds.includes(item.id) ? "played" : "notplayed"}`}>
                      <div className="card-body">
                        <div className="p-1">
                          <h6>{item.name}</h6>
                          <p className="font-xss color-light">{item.description}</p>
                          <div className="d-flex align-items-center gap-3">
                            <button
                              className="btn btn-primary font-xss px-4"
                              onClick={() =>
                                navigate(`/traits/playmodule/${item?.games[0]?.id}`, {
                                  state: { tid: item.id },
                                })
                              }
                            >
                              {`${gameIds.includes(item.id) ? "Play Again" : "Play"}`}
                            </button>
                            <span
                              className="mb-0 font-xs cursor-pointer"
                              onClick={() => navigate(`/traits/insights/${item.id}/${uuid}`)}
                            >
                              Insights
                            </span>
                          </div>
                        </div>
                      </div>
                      <img src={item.icon} style={{ width: "100px" }} className="dashimg" alt="" />
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    

    }
    </>
  );
};

export default Traits;
